export var IconSize = /*#__PURE__*/ function(IconSize) {
    IconSize["s"] = "s";
    IconSize["m"] = "m";
    IconSize["l"] = "l";
    IconSize["xl"] = "xl";
    return IconSize;
}({});
export var Variant = /*#__PURE__*/ function(Variant) {
    Variant["light"] = "light";
    Variant["dark"] = "dark";
    Variant["gradient"] = "gradient";
    Variant["lightGradient"] = "lightGradient";
    Variant["modern"] = "modern";
    return Variant;
}({});
